/* eslint-disable @typescript-eslint/no-explicit-any */
import deepmerge from 'deepmerge'

import { zIndices } from '../const'
import { generateFullScaleArray } from '../scales'
import {
  anchors,
  badges,
  borderWidths,
  buttonsTheme as buttons,
  cards,
  colors,
  elevations,
  fonts,
  forms,
  getBorders,
  getGradients,
  getRadii,
  getShadows,
  grids,
  headings,
  layout,
  lists,
  scrollbar,
  styles,
  tables,
  tabs,
  tags,
  text,
  tooltips,
  transitions
} from '../theme-keys'
import createBreakpoints from '../theme-keys/breakpoints'
import getSizes from '../theme-keys/sizes'

export default function (
  unit: 'px' | 'rem' = 'px',
  brand: 'suite' | 'loop-net' | 'apartment' = 'suite'
): any {
  const brandColors = deepmerge(
    colors,
    brand === 'loop-net'
      ? {
          primary: '#cf0000',
          secondary: '#961e00',
          muted: '#ffebeb',
          accent: '#721700',
          modes: {
            dark: {
              primary: '#d65d5d'
            }
          }
        }
      : brand === 'apartment'
        ? {
            primary: '#77b800',
            secondary: '#427b01',
            muted: '#ffebeb',
            accent: '#077eb1',
            modes: {
              dark: {
                primary: '#77b800'
              }
            }
          }
        : {}
  )
  return {
    contextId: 'base',
    useCustomProperties: false,
    useColorSchemeMediaQuery: false,
    useRootStyles: false, // need to be explicit other wise it result in a redundant Global style tag
    useLocalStorage: false,
    baseUnit: unit,
    breakpoints: createBreakpoints(),
    ...fonts,
    badges,
    borders: getBorders(colors),
    borderWidths,
    anchors,
    buttons,
    forms,
    cards,
    colors: brandColors,
    elevations,
    emSpace: generateFullScaleArray(1, 'em', 2, 64),
    fontSizes:
      unit === 'px'
        ? generateFullScaleArray(24, 'px')
        : generateFullScaleArray(24 / 16, 'rem'), // prefer rem unit but until all application remove root font override we have to stay with px unit.
    gradients: getGradients(colors),
    grids,
    headings,
    layout,
    lists,
    radii: getRadii(unit),
    scrollbar,
    shadows: getShadows(colors),
    sizes: getSizes(unit),
    space:
      unit === 'px'
        ? generateFullScaleArray(16, 'px', 2, 64)
        : generateFullScaleArray(1, 'rem', 2, 64), // prefer rem unit but until all application remove root font override we have to stay with px unit.
    styles,
    tables,
    tabs,
    tags,
    text,
    tooltips,
    transitions,
    zIndices
  }
}
